export default __webpack_public_path__ + "static/media/male_05.201f1c4d.png";